/* =========================================================================
   Penny Premium 3D — effects.js
   Decorative-only motion: story-split parallax and hero video autoplay
   guards. Everything here is skipped for reduced-motion visitors and
   degrades to a perfectly still page.
   ========================================================================= */

// motion.js folds reduced-motion, save-data and low-end into the gate
const motionFull = () => document.documentElement.classList.contains('motion-full');
const desktop = window.matchMedia('(min-width: 990px)');

/* --- Gentle parallax ------------------------------------------------------
   [data-parallax] moves between -6% and 6% translateY based on where its
   frame sits in the viewport. Desktop only; the image is pre-scaled in CSS
   (1.12) so the drift never exposes frame edges — zero CLS, zero overflow. */

function initParallax() {
  const elements = document.querySelectorAll('[data-parallax]');
  if (elements.length === 0 || !motionFull()) return;

  let ticking = false;

  const update = () => {
    ticking = false;
    if (!desktop.matches) {
      elements.forEach((el) => (el.style.transform = ''));
      return;
    }
    const viewportCenter = window.innerHeight / 2;
    elements.forEach((el) => {
      const rect = el.parentElement.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      const offset = (rect.top + rect.height / 2 - viewportCenter) / window.innerHeight;
      const shift = Math.max(-1, Math.min(1, offset)) * -6;
      el.style.transform = `translateY(${shift}%)`;
    });
  };

  const request = () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  };

  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request, { passive: true });
  update();
}

/* --- Hero video guards ----------------------------------------------------
   [data-hero-video] elements autoplay muted+inline. We pause them for
   reduced-motion / save-data visitors (poster stays visible) and pause
   offscreen heroes to save battery. */

function initHeroVideos() {
  const videos = document.querySelectorAll('video[data-hero-video]');
  if (videos.length === 0) return;

  if (!motionFull()) {
    videos.forEach((video) => {
      video.removeAttribute('autoplay');
      video.pause();
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) video.play().catch(() => {});
        else video.pause();
      });
    },
    { rootMargin: '10% 0px' }
  );

  videos.forEach((video) => observer.observe(video));
}

function initAll() {
  initParallax();
  initHeroVideos();
}

initAll();
document.addEventListener('shopify:section:load', initAll);
